import { AtivoInativoEnum } from "../enum/ativo-inativo.enum";

export class AtivoInativoDialogData {
  constructor(
    public situacao: AtivoInativoEnum,
    public idRegistro: number,
    public justificativa: string = '',
  ) {}
}
